import clsx from 'clsx';
import { LoadingSpinner, Stack } from 'components';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getClinicalEncountersPreview } from 'store/clinicalEncounters/clinicalEncountersActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import style from './clinicalEncounters.module.scss';
import ClinicalEncountersModal from './clinicalEncountersModal';

const ClinicalEncounters = () => {
  const { clientId } = useParams();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const { clinicalEncountersPreviewList, clinicalEncountersPreviewListLoading } = useAppSelector(
    (state) => state.clinicalEncounters
  );

  useEffect(() => {
    if (clientId) {
      dispatch(
        getClinicalEncountersPreview({
          clientId
        })
      );
    }
  }, []);

  const handleModalOpen = () => setOpen(true);

  return (
    <Stack width="100%" mb="16px" data-test-id="clinical-encounters">
      <Stack className={style.wrapper} flexDirection="row">
        <p className={style.title}>Clinical Encounters</p>
        <span onClick={handleModalOpen} className={clsx('material-icons-outlined', style.icon)}>
          open_in_new
        </span>
      </Stack>
      {open && <ClinicalEncountersModal open={open} setOpen={setOpen} />}
      {clinicalEncountersPreviewListLoading ? (
        <Stack width="100%" height="100%" justifyContent="center" alignItems="center" mt="16px">
          <LoadingSpinner />
        </Stack>
      ) : clinicalEncountersPreviewList?.length > 0 ? (
        <Stack onClick={handleModalOpen} gap="8px" mx="12px" mt="12px" sx={{ cursor: 'pointer' }}>
          {clinicalEncountersPreviewList.map((item) => (
            <Stack flexDirection="row" justifyContent="space-between" fontSize="12px" key={item.id}>
              <div className={style.locationText}>{item.location || '-'}</div>
              <div style={{ fontVariantNumeric: 'tabular-nums' }}>
                {item.dateOfEncounter ? dayjs(item.dateOfEncounter).format('M/DD/YY') : '-'}
              </div>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Stack ml="16px" mt="12px" fontSize="12px">
          No encounters
        </Stack>
      )}
    </Stack>
  );
};

export default ClinicalEncounters;
